import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment, ConstVariable } from '../../environments/environment';
import { ModulePortalMappingMenuInfo } from '../model/ModulePortalMappingMenu';
import { GlobalService } from '../service/global.service';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-menu-portal',
  templateUrl: './menu-portal.component.html',
  styleUrls: ['./menu-portal.component.css']
})
export class MenuPortalComponent implements OnInit {
  _ParamModuleID: string
  baseurl: any;
  ModuleMenuList: ModulePortalMappingMenuInfo[];
  LandingBG: string;
  LandingText: string;
  LandingFontColor: string;
  constructor(private httpClient: HttpClient, private router: ActivatedRoute, private formBuilder: FormBuilder, private router2: Router, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
    
  }

  ngOnInit(): void {
    this.router.params.subscribe(params => {
      this._ParamModuleID = params['ModulePortalId'];
      this.InitialBackground(this._ParamModuleID);
    });
    this.LoadMenuPortal().then(data => {
      this.ModuleMenuList = data;
      this.RedirectToMainPage(this._ParamModuleID)
    })
    
  }
  async LoadMenuPortal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var objectjson = {};

      objectjson['ModulePortalId'] = this._ParamModuleID;


      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/GetModulePortalMappingMenu",
          strjson, httpOptions)
        .toPromise()
    }
  }
  LinkRouter(menupath) {
    this.router2.navigate([menupath])
  }
  InitialBackground(moduleId) {
    
    switch (moduleId) {
      case "1":
        this.LandingFontColor = "#20A2C0";
        this.LandingText = "Sale Funnel";
        this.LandingBG = '../../assets/Image/bg_landing/bg_sale_funnel.png';
        break;
      case "2":
        this.LandingFontColor = "#44BA94";
        this.LandingText = "Project Delivery";
        this.LandingBG = '../../assets/Image/bg_landing/bg_project_delivery.png';
        break;
      case "3":
        this.LandingFontColor = "#8AC541";
        this.LandingText = "Support Service";
        this.LandingBG = '../../assets/Image/bg_landing/bg_support_serve.png';
        break;
      case "4":
        this.LandingFontColor = "#7079B3";
        this.LandingText = "3 Axis";
        this.LandingBG = '../../assets/Image/bg_landing/bg_3Axis.png';
        break;
      default:
        this.LandingFontColor = "#D6AF0F";
        this.LandingText = "Admin";
        this.LandingBG = '../../assets/Image/bg_landing/bg_admin.png';
        break;
    }
  }
  OnBtnBackClick() {
    this.router2.navigate(['/portal']);
  }

  //Redirect to main page
  RedirectToMainPage(moduleId)
  {
    switch (moduleId) {

      case ConstVariable.ModuleSale:
        this.LinkRouter('/sale-homepage');
        break;
      case ConstVariable.ModuleProjectDelivery:
        this.LinkRouter('/project-management');
        break;
      case ConstVariable.ModuleSupport:
        this.LinkRouter('/ticket-worklist');
        break;
      case ConstVariable.Module3Axis:
        this.LinkRouter('/timesheet-worklist');
        break;
      case ConstVariable.ModuleMaster:
        this.LinkRouter('/user-management');
        break;
      default:

    }
  }
}


